const mediaItems = [
  {
    title: '韩漫下载安装教程 · 新手入门篇',
    desc: '从零开始，三分钟学会下载安装韩漫APK',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20tutorial%20style%20illustration%20showing%20steps%20to%20download%20Korean%20webtoon%20app%20on%20smartphone%2C%20clean%20instructional%20design%2C%20warm%20coral%20and%20cream%20colors%2C%20modern%20flat%20illustration%2C%20step%20by%20step%20visual%20guide&width=800&height=450&seq=media-01&orientation=landscape',
    duration: '03:25',
  },
  {
    title: '2026年韩漫推荐 · 十大必看新作',
    desc: '年度精选韩漫新作大盘点，追更必看',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20top%20ten%20list%20style%20graphic%20with%20Korean%20manhwa%20cover%20art%20collage%2C%20ranking%20design%2C%20warm%20cream%20background%2C%20coral%20accent%20highlights%2C%20clean%20editorial%20layout&width=800&height=450&seq=media-02&orientation=landscape',
    duration: '08:12',
  },
  {
    title: '韩漫离线阅读 · 功能深度体验',
    desc: '实测各大韩漫APP离线功能表现',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20review%20style%20illustration%20of%20a%20tablet%20showing%20Korean%20webtoon%20in%20offline%20reading%20mode%2C%20cozy%20environment%2C%20warm%20lighting%2C%20product%20review%20aesthetic%2C%20clean%20composition&width=800&height=450&seq=media-03&orientation=landscape',
    duration: '05:48',
  },
  {
    title: '韩漫之家 · 平台使用全攻略',
    desc: '韩漫之家全部功能介绍与使用技巧',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20platform%20guide%20illustration%20showing%20Korean%20webtoon%20website%20features%2C%20organized%20dashboard%20style%2C%20warm%20coral%20and%20cream%20theme%2C%20modern%20UI%20design%2C%20clean%20layout&width=800&height=450&seq=media-04&orientation=landscape',
    duration: '06:30',
  },
];

export default function Media() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            视频攻略
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            韩漫下载安装与使用的视频教程合集
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-100">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  title={`韩漫之家 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-xl text-primary-600 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/60 text-white text-xs font-medium">
                  {item.duration}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 line-clamp-1 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-1">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}